import LoginPage from "@/pages/login/page";
import { createFileRoute, redirect } from "@tanstack/react-router";
import { RouteUrl } from "@/configs/router/routes";

const TENANT_STORAGE_KEY = "hockeyly_selected_tenant";

export const Route = createFileRoute("/login")({
    component: LoginPage,
    beforeLoad: async () => {
        const storedTenant = localStorage.getItem(TENANT_STORAGE_KEY);
        if (storedTenant) {
            throw redirect({ to: RouteUrl.Dashboard, replace: true });
        }
    },
});
